module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/dashboard1-2c4fbf7d19e0512198f03714a06f2790.png";